import {
  fetchNotificationUnreadCount,
  fetchNotifications,
  markAllNotificationsRead,
  markNotificationRead
} from '../api/system'

function normalizePagedData(data) {
  return {
    ...data,
    list: data?.list || data?.content || [],
    content: data?.content || data?.list || [],
    total: data?.total ?? data?.totalElements ?? 0,
    totalElements: data?.totalElements ?? data?.total ?? 0
  }
}

async function fetchUserNotifications(filters) {
  const response = await fetchNotifications(filters.page, filters.pageSize, {})

  return {
    ...response,
    data: normalizePagedData(response.data)
  }
}

function fetchUserNotificationUnreadCount() {
  return fetchNotificationUnreadCount()
}

function markUserNotificationRead(notificationId) {
  return markNotificationRead({
    id: notificationId
  })
}

function markAllUserNotificationsRead() {
  return markAllNotificationsRead()
}

export {
  fetchUserNotificationUnreadCount,
  fetchUserNotifications,
  markAllUserNotificationsRead,
  markUserNotificationRead
}
